import client from '@/plugins/axios.js'


export default {
  getProfile() {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).get('/api/dealer/profile')
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  getProfileDraft() {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).get('/api/dealer/profileDraft')
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  storeProfile(tsData){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/dealer/profile',tsData)
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  uploadProfileImage(formData){
    return new Promise((resolve,reject)=>{
        client({requiresAuth:true, fileUpload:true}).post('/api/media/upload', formData)
            .then((res)=>{
                resolve(res.data.data)
            })
            .catch((err)=>{
                reject(err)
            })
    })
  },

  /*Erik hook*/
  setProfileSettings(payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/admin/profileSettings', payload)
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{
          reject(err)
        })
    })
  },

  getProfileSettings(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/admin/profileSettings')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  adminStoreProfile(tsData){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/admin/profile',tsData)
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getAllActiveProfiles() {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).get('/api/admin/profiles/active/1/draft/0')
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  getAllDraftProfiles() {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).get('/api/admin/profiles/active/0/draft/1')
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  getPreApproveDraftProfile(id) {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).get('/api/admin/profile/preApprove/' + id)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  approveDraftProfile(id) {
    return new Promise((resolve, reject) => {
      client({requiresAuth:true}).post('/api/admin/profile/approve/' + id)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

}
